import { render } from "./Sidenav.vue?vue&type=template&id=6298a89f&ts=true"
import script from "./Sidenav.vue?vue&type=script&lang=ts"
export * from "./Sidenav.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__